import $ from "jquery";

$.validator.addMethod("requriedyearandmonth", function (value, element, parameters) {
	var isValid = true,
		formGroup = $(element).closest(".form-group");

	// console.log("requriedyearandmonth");

	$.each(parameters, function (i, id) {
		var control = formGroup.find("#" + id);

		// console.log(control);

		if (!control.val()) {
			isValid = false;
		}
	});

	return isValid;

});
$.validator.unobtrusive.adapters.add("requriedyearandmonth", ["yearpropertyname", "monthpropertyname"], function (options) {
	options.rules["requriedyearandmonth"] = {
		yearpropertyname: options.params["yearpropertyname"],
		monthpropertyname: options.params["monthpropertyname"]
	};
	options.messages["requriedyearandmonth"] = options.message;
});